import React, { Component } from 'react'
import API from '../Utils/api'
import qs from 'qs'
import Logo from '../Img/logo.png'
import { Alert } from 'react-bootstrap'

import { Link } from 'react-router-dom'


class ValidacaoRegistro extends Component {
    constructor(props) {
        super(props)
        this.query = qs.parse(props.location.search, { ignoreQueryPrefix: true })
        this.state = {
            message: '',
            error: '',
            toggleExpand: false
        }
    }

    componentDidMount() {
        setTimeout(this.validateToken, 5000)

    }

    expandir = () => {
        this.setState({ toggleExpand: !this.state.toggleExpand })
    }

    validateToken = async () => {
        try {
            const { token } = this.query
            if (!token) throw new Error('Token não fornecido')

            const { data } = await API.post('/api/tokens/validacao', { token })
            if (data.error) {
                this.setState({ error: data.error })
            }

            this.setState({ message: data.message })
        } catch (error) {
            this.setState({ error: error.message })
        }
    }

    render() {
        const success = this.state.message
        const error = this.state.error

        return (
            <div className="documentation">
                <nav
                    className={
                        this.state.toggleExpand
                            ? 'navbar navbar-expand-lg  navbar-dark bg-dark'
                            : 'navbar navbar-expand-lg  navbar-transparent'
                    }
                    color-on-scroll="500"
                >
                    <div className="  container-fluid ">
                        <button
                            to="#"
                            className="navbar-toggler navbar-toggler-right"
                            type="button"
                            data-toggle="collapse"
                            aria-controls="navigation-index"
                            aria-expanded={this.state.toggleExpand}
                            aria-label="Toggle navigation"
                            onClick={this.expandir}
                        >
                            <span className="navbar-toggler-bar burger-lines"/>
                            <span className="navbar-toggler-bar burger-lines"/>
                            <span className="navbar-toggler-bar burger-lines"/>
                        </button>
                        <div
                            className={
                                this.state.toggleExpand
                                    ? 'w-100 justify-content-end  show'
                                    : 'collapse navbar-collapse justify-content-end '
                            }
                            id="navigation"
                        >
                            <ul
                                className={
                                    this.state.toggleExpand
                                        ? 'rounded navbar-nav bg-dark'
                                        : 'rounded navbar-nav '
                                }
                                id
                            >
                                <li className="nav-item">
                                    <Link className="nav-link" to="#">
                                        Contato
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/regulamento">
                                        Regulamento
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/login">
                                        Fazer Login
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div className="wrapper">
                    <div className="page-header clear-filter" filter-color="purple">
                        <div
                            className="page-header-image"
                            data-parallax="true"
                        >
                            <div className="filter"/>
                            <div className="title-container text-center" style={{top: 180}}>
                                <img style={{ width: '18em' }} src={Logo}/>
                                <div className="mt-4 p-3 container">
                                    {!success && !error && (
                                        <p>Aguarde um instante, estamos verificando suas informações...</p>)}
                                    {success && (<Alert className={'rounded'} variant={'success'} ><Alert.Heading>🤩 Ótimo...</Alert.Heading><p>{success}</p></Alert>)}
                                    {error && (<Alert className={'rounded'} variant={'danger'}><Alert.Heading>😔 Sentimos
                                        muito...</Alert.Heading><hr/><p>{error}</p></Alert>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ValidacaoRegistro